// CAmbiar toda esta vaina para que lea de las variables de ambiente
const apiSettings = {
    hammurabi: {
        url: process.env.REACT_APP_HAMMURABI_API,
        key: process.env.REACT_APP_HAMMURABI_KEY,
        keyName: process.env.REACT_APP_HAMMURABI_KEY_NAME,
    },
};

export default apiSettings;
